// extracted by mini-css-extract-plugin
export default {"titleWrapper":"GalleryComponent_titleWrapper__Ku9FD","thumbnailWrapper":"GalleryComponent_thumbnailWrapper__sqbBO"};